export default function getCookie(name) {
  const matches = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return matches ? matches[2] : null;
}
